import styles from "./TextQuestion.module.scss";

import { ChangeEvent, useCallback } from "react";

import { useTranslation } from "react-i18next";

import { SurveyQuestionComponentProps } from "@/modules/session-survey/types/SurveyQuestionComponentProps";
import { AppInput } from "@/modules/shared/components/AppInput";

export const TextQuestion = ({
  question,
  value,
  onAnswer,
}: SurveyQuestionComponentProps) => {
  const { t } = useTranslation();
  const inputId = `survey-question-${question.id}`;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onAnswer(event.target.value);
    },
    [onAnswer],
  );

  return (
    <section className={styles.container}>
      <h2 className={styles.prompt}>
        <label htmlFor={inputId}>{question.prompt}</label>
      </h2>
      <AppInput
        id={inputId}
        type="textarea"
        value={typeof value === "string" ? value : ""}
        onChange={handleChange}
        placeholder={t("sessionSurvey.text.placeholder")}
        className={styles.input}
        autoGrow={false}
        maskInReplay
      />
    </section>
  );
};
